import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, AfterViewInit, ViewChild, Compiler, Injector, NgModule, NgModuleRef, TemplateRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { LogService } from '../../../services/log.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoadinganimationComponent } from './loadinganimation/loadinganimation.component';
import { MenuComponent } from './menu/menu.component';
import { SettingsvalueComponent } from './settingsvalue/settingsvalue.component';
import { SetvalueComponent } from './setvalue/setvalue.component';
import { WeekOverviewComponent } from './week-overview/week-overview.component';
import { ZeitwahlComponent } from './zeitwahl/zeitwahl.component';
import { TimesetComponent } from './timeset/timeset.component';
import { TextComponent } from './text/text.component';
import { QuickactionComponent } from './quickaction/quickaction.component';
import { ToastComponent } from './toast/toast.component';
import { HelpScreenComponent } from './help-screen/help-screen.component';
import { ListComponent } from './list/list.component';
import { MenuShowcaseComponent } from './menu-showcase/menu-showcase.component';
import { ControlShowcaseComponent } from './control-showcase/control-showcase.component';
import { IdleComponent } from './idle/idle.component';
import { DayPlannerOverviewComponent } from './day-planner-overview/day-planner-overview.component';
import { DayPlannerComponent } from './day-planner/day-planner.component';
import { ShowValueComponent } from './show-value/show-value.component';
import { WaterpressureComponent } from './waterpressure/waterpressure.component';
import { DataIoService } from '../../../services/data-io.service';
import { SplashComponent } from '../../../widgets/helpers/splash/splash.component';
import { ConfigService } from '../../../services/config.service';
import { SubtreeWrapComponent } from 'src/app/subtree-wrap/subtree-wrap.component';

@Component({
    selector: 'app-screen',
    templateUrl: './screen.component.html',
    styleUrls: ['./screen.component.scss'],
    standalone: false
})
export class ScreenComponent implements OnInit {
	_debug: boolean = false;
	subscription: any;
	muted: boolean = true;
	@ViewChild('content1', { read: ViewContainerRef, static: false }) contentRef1: ViewContainerRef;
	@ViewChild('content2', { read: ViewContainerRef, static: false }) contentRef2: ViewContainerRef;
	current: ViewContainerRef;
	constructor(
		private log: LogService,
		private menuService: MenuService,
		private configService: ConfigService,
		private ioService: DataIoService,
		private vcr: ViewContainerRef,
		private cfr: ComponentFactoryResolver,
	) {
		//this._debug = (!environment.production);
		this.debug("constructor()");
		this.configService.events$.subscribe(
			(event) => {
				if (event == 'language_changed') {
					this.reloadCurrentPanel();
				}

			}
		);
		this.subscription = this.ioService.inputs.events$.subscribe(
			(event) => {
				this.eventHandler(event);
			}
		);
		/*
		if( this.configService.simulatorConfig.hasBattery() ){
			this.startDisplayTimeout();
			this.ioService.inputs.events$.subscribe(
				(event)=>{
					if(['up','down','menu','confirm','menu','question','panup','pandown','back'].includes(event)){
						this.resetDisplayTimeout();
					}
				}
			);
		}
		*/
	}

	getScreenTemplate(): string {
		return this.menuService.getCurrentNode().getScreenTemplate();
	}

	eventHandler(event) {
		if (this.muted) {
			return;
		}
		switch (event) {
			case 'reinit_template_down': {
				this.debug("reinit template");
				this.showComponent('down');
				return;
			}
			case 'reinit_template_up': {
				this.debug("reinit template");
				this.showComponent('up');
				return;
			}
			case 'reinit_template': {
				this.debug("reinit template");
				this.showComponent();
				return;
			}
			case 'menu': {
				let currentMenuIdentifier = this.menuService.getCurrentNode().getIdentifier();
				// controlshowcase
				if (currentMenuIdentifier.startsWith('controlshowcase') || currentMenuIdentifier.startsWith('wizard-controlshowcase')) {
					return;
				}
				if (this.menuService.getCurrentNode().getButtons().includes('menu')) {
					if (currentMenuIdentifier != "dashboard" && currentMenuIdentifier != 'blockingstate') {
						this.menuService.goto(this.menuService.findItem('dashboard'));
					} else {
						this.menuService.goto(this.menuService.findItem('mainmenu'));
					}
				}
				return;
			}

		}
	}

	_displayTimeoutHandle = null;
	_displayTimedout = false;
	_displayTimoutInterval = 30000;
	resetDisplayTimeout() {
		this.clearDisplayTimeout();
		this.startDisplayTimeout();
	}
	startDisplayTimeout() {
		this._displayTimedout = false;
		if (!this.configService.simulatorConfig.hasBattery()) {
			return;
		}
		this._displayTimeoutHandle = setTimeout(() => {
			this.onDisplayTimeout();
		}, this._displayTimoutInterval);
	}
	clearDisplayTimeout() {
		if (this._displayTimeoutHandle != null) {
			clearTimeout(this._displayTimeoutHandle);
			this._displayTimeoutHandle = null;
		}
	}
	onDisplayTimeout() {
		this._displayTimedout = true;
		this.clearDisplayTimeout();
	}

	get brightness() {
		if (this.ioService.getDeviceInfo().getValue('powerstate') == 'off') {
			return '1';
		}
		if (this._displayTimedout) {
			return '1';
		}
		let brightness = this.ioService.deviceInfo().getScale('brightness').getCurrentValue();
		return (0.05 * (10.0 - (brightness * 1.0))).toString();
	}
	resolveComponent(screenType: string): any {
		this.debug("Resolving screenType: " + screenType);
		switch (screenType) {
			case 'subtree': return SubtreeWrapComponent
			case 'dashboard': return DashboardComponent;
			case 'loadinganimation': return LoadinganimationComponent;
			case 'menu': return MenuComponent;
			case 'timeset': return TimesetComponent;
			case 'quick-action':
			case 'quickaction': return QuickactionComponent;
			case 'help': return HelpScreenComponent;
			case 'text': return TextComponent;
			case 'toast': return ToastComponent;
			case 'list': return ListComponent;
			case 'settingsvalue': return SettingsvalueComponent;
			case 'setvalue': return SetvalueComponent;
			case 'idle': return IdleComponent;
			case 'splash': return SplashComponent;
			case 'zeitwahl': {
				return ZeitwahlComponent;
			}
			case 'waterpressure': {
				return WaterpressureComponent;
			}
			case 'menu-showcase':
			case 'menushowcase': {
				return MenuShowcaseComponent
			}
			case 'showvalue': {
				return ShowValueComponent;
			}
			case 'control-showcase':
			case 'controlshowcase': {
				return ControlShowcaseComponent;
			}
			case 'week-overview':
			case 'week-planner':
			case 'week-planner-overview': return WeekOverviewComponent;
			case 'day-planner-overview': return DayPlannerOverviewComponent;
			case 'day-planner': return DayPlannerComponent;
			default: {
				this.debug("No Component known for " + screenType);
				return null;
			}
		}
	}
	onScreenRef: ViewContainerRef;
	offScreenRef: ViewContainerRef;

	showComponent(direction?: "up" | "down") {

		let osr = this.offScreenRef;

		//if(this.onScreenRef.get(0)){
		//	this.onScreenRef.get(0).destroy();
		//}



		this.debug("creating factory");
		let component = this.resolveComponent(this.menuService.currentNode.getScreenTemplate());
		if (component === null) {
			return;
		}
		this.ioService.inputs.mute();
		const factory = this.cfr.resolveComponentFactory(component);
		this.debug("##### creating ref for " + this.menuService.getCurrentNode().getScreenTemplate());

		const ref = osr.createComponent(factory);
		this.debug("detecting changes.");
		ref.changeDetectorRef.detectChanges();

		this.switchPanels(direction);
	}
	reloadCurrentPanel() {
		return;
		console.log("Reloading panel.");
		let osr = this.offScreenRef;
		if (osr) {

			if (osr.get(0)) {
				osr.get(0).destroy();
			}
			let component = this.resolveComponent(this.menuService.getCurrentNode().getScreenTemplate());
			if (component === null) {
				return;
			}

			const factory = this.cfr.resolveComponentFactory(component);
			this.debug("##### creating ref for " + this.menuService.getCurrentNode().getScreenTemplate());

			const ref = osr.createComponent(factory);
			this.debug("detecting changes.");
			ref.changeDetectorRef.detectChanges();
		} else {
			console.log("OnScreenReference was null");
		}

	}
	clearOffScreenComponent() {
		if (this.offScreenRef == null) {
			return;
		}
		if (this.offScreenRef.get(0)) {
			this.offScreenRef.get(0).destroy();
		}

		this.offScreenRef.clear();
	}
	getClass(str) {
		let classes;
		classes = {
			'left-to-in': (str == 'left-to-in'),
			'in-to-left': (str == 'in-to-left'),
			'right-to-in': (str == 'right-to-in'),
			'in-to-right': (str == 'in-to-right')
		};
		return classes;
	}
	firstClass() {
		return this.getClass(this._firstClass);
	}
	secondClass() {
		return this.getClass(this._secondClass);
	}
	_firstClass = "";
	_secondClass = "";
	animationTime = 200;
	switchPanels(_direction?: "up" | "down") {

		let direction = _direction;
		if (this.onScreenRef == this.contentRef1) {
			switch (direction) {
				case 'down': {
					this._firstClass = "in-to-left";
					this._secondClass = "right-to-in";
					break;
				}
				case 'up': {
					this._firstClass = "in-to-right";
					this._secondClass = "left-to-in";
					break;
				}
				default: {
					this._firstClass = '';
					this._secondClass = '';
				}
			}
		}
		if (this.onScreenRef == this.contentRef2) {

			switch (direction) {
				case 'down': {
					this._firstClass = "right-to-in";
					this._secondClass = "in-to-left";
					break;
				}
				case 'up': {
					this._firstClass = "left-to-in";
					this._secondClass = "in-to-right";
					break;
				}
				default: {
					this._firstClass = '';
					this._secondClass = '';
				}
			}
		}
		if (this._firstClass != '' && this._secondClass != '') {

			setTimeout(() => {
				this.swapContainers();
				this.clearOffScreenComponent();
				this.ioService.inputs.unmute();

			}, this.animationTime);
		} else {
			this.swapContainers();
			this.clearOffScreenComponent();
			this.ioService.inputs.unmute();
		}

	}
	swapContainers() {
		if (this.onScreenRef == this.contentRef1) {
			this.onScreenRef = this.contentRef2;
			this.offScreenRef = this.contentRef1;
		} else {
			this.onScreenRef = this.contentRef1;
			this.offScreenRef = this.contentRef2;

		}

	}
	getCurrentRef() {
		return this.contentRef1;
	}
	showComponent_() {

		this.debug("creating factory");
		let component = this.resolveComponent(this.menuService.currentNode.getScreenTemplate());
		if (component === null) {
			return;
		}
		const factory = this.cfr.resolveComponentFactory(component);
		this.debug("##### creating ref for " + this.menuService.getCurrentNode().getScreenTemplate());

		const ref = this.getCurrentRef().createComponent(factory);

		this.debug("detecting changes.");
		ref.changeDetectorRef.detectChanges();
		this.debug("done");

	}
	/*
	removeComponent(ref : ViewContainerRef){ 
		let currentElement = ref.get(0);
		if(currentElement){
			currentElement.destroy();
		}
		ref.clear();
	}*/
	ngOnInit() {
		this.muted = false;

		this.debug("onInit");
		this.menuService.reset();
		this.debug("showing dashboard.");

		this.showComponent();
	}
	ngOnDestroy() {
		this.muted = true;
	}
	ngAfterViewInit() {
		this.debug("NgAfterViewInit()");
		this.onScreenRef = this.contentRef1;
		this.offScreenRef = this.contentRef2;
	}

	debug(msg: string) {
		if (this._debug) {
			console.log("ScreenComponent: " + msg);
		}
	}
}
